import { on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { LocationSetTypesActions, LocationSetTypeAsyncActions } from './location-set-types.actions';
import { ManagementBaseActions } from '../base/management-base.actions';
import {LocationSetType} from '@emm/core/models/location-set-type.model';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {SearchFilter} from '@emm/core/models/search-filter';
import {sortByWeight, withLoadables} from '@emm/core/util/ngrx.util';

export const locationSetTypesFeatureKey = 'locationSetTypes';

export interface LocationSetTypesState extends EntityState<LocationSetType>, AsyncActionState {
    selectedTag: string | null;
    searchFilter: SearchFilter;
}

export const adapter: EntityAdapter<LocationSetType> = createEntityAdapter<LocationSetType>({
    selectId: (item: LocationSetType) => item.tag,
    sortComparer: sortByWeight,
});

export const initialState: LocationSetTypesState = adapter.getInitialState({
    selectedTag: null,
    searchFilter: null,
    ...asyncActionState.initial,
});

const { loadActions, successActions, errorActions } = LocationSetTypeAsyncActions;

export const locationSetTypesReducer = withLoadables<LocationSetTypesState>({
    loadActions,
    successActions,
    errorActions
})(
    initialState,

    on(ManagementBaseActions.initLocationSetTypes, ManagementBaseActions.initLocationSets, () => ({
        ...initialState
    })),

    on(
        LocationSetTypesActions.load,
        LocationSetTypesActions.deleteSuccess,
        LocationSetTypesActions.loadFromLocationSets,
        (state: LocationSetTypesState) => ({
            ...state,
            selectedTag: null
        })
    ),

    on(
        LocationSetTypesActions.loadSuccess,
        LocationSetTypesActions.loadFromLocationSetsSuccess,
        (state: LocationSetTypesState, { locationSetTypes }) => adapter.setAll(locationSetTypes, state)
    ),

    on(
        LocationSetTypesActions.select,
        LocationSetTypesActions.selectFromLocationSets,
        (state: LocationSetTypesState, { tag }) => ({
            ...state,
            selectedTag: tag
        })
    ),

    on(LocationSetTypesActions.searchLocationSetTypes, (state: LocationSetTypesState, { filter }) => ({
        ...state,
        searchFilter: filter
    })),

    on(ManagementBaseActions.updateLocationSetTypeSuccess, (state: LocationSetTypesState, action) =>
        adapter.upsertOne(action.locationSetType, state)
    )

);
